import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import SurveyDetail from "./scenes/surveyDetail/index.jsx";
import Surveys from "./scenes/surveys";
import Researchers from "./scenes/researchers";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider, Box, CircularProgress } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import RedirectSurvey from "./scenes/redirectSurvey";
import Login from "./scenes/login";
import { SESSION_KEY } from "./api";

function App() {
  const [theme, colorMode] = useMode();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      if (raw) {
        const session = JSON.parse(raw);
        if (session?.id != null && session?.type) {
          setRole(session.type);
          setIsAuthenticated(true);
        }
      }
    } catch (e) {
      sessionStorage.removeItem(SESSION_KEY);
    }
    setLoading(false);
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {loading ? (
          <Box
            minHeight="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress />
          </Box>
        ) : !isAuthenticated ? (
          <Login
            onLoggedIn={(session) => {
              setRole(session.type);
              setIsAuthenticated(true);
            }}
          />
        ) : (
          <div className="app">
            <Sidebar />
            <main className="content">
              <Routes>
                <Route path="/" element={<Dashboard role={role} />} />
                <Route path="/survey-detail/:id" element={<SurveyDetail role={role} />} />
                <Route path="/researchers" element={<Researchers role={role} />} />
                <Route path="/surveys" element={<Surveys role={role} />} />
                <Route path="/surveys/:userId" element={<RedirectSurvey role={role} />} />
                <Route path="/form" element={<Form />} />
                <Route path="/bar" element={<Bar role={role} />} />
                <Route path="/line" element={<Line role={role} />} />
                <Route path="/geography" element={<Geography />} />
              </Routes>
            </main>
          </div>
        )}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
export default App;
